import { Box, Text, WizardStepRenderParams, useOnNext } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { InstitutionHorizontalCard } from 'modules/banking/components/InstitutionCard/horitzontal'
import { WizardData } from 'modules/banking/components/NewAccountModal/types'
import { WizardStepLayout } from 'modules/banking/components/NewAccountModal/wizardSteps/WizardStepLayout'

export const BankAccountConnectionWizardStep = ({ data }: WizardStepRenderParams<WizardData>) => {
  if (!data.institution) {
    return null
  }

  const maxDays = Math.min(data.institution.transactionTotalDays, 180).toString()
  // As there is another step using this.. we have to override the onNext callback
  useOnNext(() => Promise.resolve())

  return (
    <WizardStepLayout
      title={i18n.t('banking.accounts.new_wizard.step_3_1.title')}
      subtitle={i18n.t('banking.accounts.new_wizard.step_3_1.subtitle')}
    >
      <Box width="full" flexDirection="row" gap="s12">
        <Box style={{ width: '500px' }} flexNoShrink flexDirection="column" gap="s16">
          <Text.Normal size="300" weight="semibold">
            {i18n.t('banking.accounts.new_wizard.step_3_1.bank_account')}
          </Text.Normal>
          <InstitutionHorizontalCard institution={data.institution} />
          <Text.Normal size="300" weight="semibold">
            {i18n.t('banking.accounts.new_wizard.step_3_1.callout_title')}
          </Text.Normal>
          <Text.Normal size="300" weight="normal">
            {i18n.t('banking.accounts.new_wizard.step_3_1.callout_description', {
              days: maxDays,
            })}
          </Text.Normal>
          <Text.Normal size="300" weight="semibold">
            {i18n.t('banking.accounts.new_wizard.step_3_1.security_title')}
          </Text.Normal>
          <Text.Normal size="300" weight="normal">
            {i18n.t('banking.accounts.new_wizard.step_3_1.security_description')}
          </Text.Normal>
        </Box>
      </Box>
    </WizardStepLayout>
  )
}
